import { IApplicationState } from '../../types/redux';

export const getName = (state: IApplicationState): string | null => {
  return state.newReview.data.name;
};
